const enum RentalAdjustmentTypeEnum {
  INDEX_RENT = 'INDEX_RENT',
  COMPARABLE_RENT = 'COMPARABLE_RENT',
  GRADUATED_RENT = 'GRADUATED_RENT',
  NO_ADJUSTMENT = 'NO_ADJUSTMENT',
}
type RentalAdjustmentType =
  | RentalAdjustmentTypeEnum.INDEX_RENT
  | RentalAdjustmentTypeEnum.COMPARABLE_RENT
  | RentalAdjustmentTypeEnum.GRADUATED_RENT
  | RentalAdjustmentTypeEnum.NO_ADJUSTMENT;

type Tier = {
  date: string | null | undefined;
  rent: number | null | undefined;
};

interface RentalAdjustmentInterface {
  rentalAdjustment: RentalAdjustmentType;
  tiers: Tier[];
  rentRegulation: boolean;
  firstUsedAndRented: boolean;
  renovationsLastThreeYears: boolean;
  occupancyAfterRenovations: boolean;
}
export { RentalAdjustmentInterface, RentalAdjustmentType, RentalAdjustmentTypeEnum, Tier };
